import { render, staticRenderFns } from "./AdminSettings.vue?vue&type=template&id=3f51c422&scoped=true"
import script from "./AdminSettings.vue?vue&type=script&lang=ts"
export * from "./AdminSettings.vue?vue&type=script&lang=ts"
import style0 from "./AdminSettings.vue?vue&type=style&index=0&id=3f51c422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f51c422",
  null
  
)

export default component.exports